import { render, staticRenderFns } from "./ItemAprobado.vue?vue&type=template&id=01749f22&"
import script from "./ItemAprobado.vue?vue&type=script&lang=js&"
export * from "./ItemAprobado.vue?vue&type=script&lang=js&"
import style0 from "./ItemAprobado.vue?vue&type=style&index=0&id=01749f22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports